module.exports = __webpack_public_path__ + "static/media/solid.06e540d6.jpg";